<template>
  <div class="header">
    <div id="header">
      <div class="logo">
        <a
          class="link"
          target="_blank"
          rel="noreferrer"
          href="https://www.empreinte.com/"
        >
          <img src="static/img/logo-emp.png" alt="empreinte_logo" />
        </a>
      </div>
      <!--
      <div id="menu">
        <ul>
          <li class="current_page_item"><a href="#" accesskey="1" title="">Homepage</a></li>
          <li><a href="#" accesskey="2" title="">Our Clients</a></li>
          <li><a href="#" accesskey="3" title="">About Us</a></li>
          <li><a href="#" accesskey="4" title="">Careers</a></li>
          <li><a href="#" accesskey="5" title="">Contact Us</a></li>
        </ul>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "header-fo",
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// Header.vue?15d27a1c